import React from 'react';
import {Box, Typography} from '@mui/material';
import './ReviewRateTrendWidget.scss';
import ArrWidgetWrapper from '../../../common/arr-widget-wrapper/ArrWidgetWrapper';
import ArrLineChart from '../../../common/arr-linechart/ArrLineChart';
import {t} from 'i18next';
import {useReviewRate} from '../../../../hooks/dashboard/useDashboard';

interface ReviewRateProps {
  onReplaceClick: () => void;
  reviewerCount: number;
  isDefault: boolean;
}
const ReviewRateTrendWidget: React.FC<ReviewRateProps> = ({
  onReplaceClick,
  reviewerCount,
  isDefault,
}) => {
  const {data, isLoading: loading, isError: error} = useReviewRate(isDefault);

  return (
    <ArrWidgetWrapper
      title={t('dashboard.reviewRateWidget.widgetTitle')}
      tooltipContent={t('dashboard.reviewRateWidget.tooltip')}
      showInfo
      showReplace
      onReplaceClick={onReplaceClick}
      loading={loading}
      error={error}
    >
      <Box className="review-rate-root">
        <Typography
          className="typo-text subhead5_size"
          data-testid={`review-rate-trend-widget-all-reviews`}>
          {t('dashboard.reviewRateWidget.allReviews')}
        </Typography>
        <Typography
          className="typo-text display2_size"
          data-testid={`reviewers-rate-all-reviewers`}
        >
          {reviewerCount}
        </Typography>

        <Box className="review-rate-chat">
          {data && (
            <ArrLineChart
              data={data.map((item) => ({
                xAxisData: item.dayElapsed.slice(0, 3),
                yAxisData: item.docCount,
              }))}
              title={t('dashboard.reviewRateWidget.reviewDay')}
              preserveZoom
              yAxisConfig={{
                valueFormatter: (value: number) => {
                  return Number.isInteger(value) ? String(value) : '';
                },
              }}
            />
          )}
        </Box>
      </Box>
    </ArrWidgetWrapper>
  );
};

export default ReviewRateTrendWidget;
